import { Button, Dialog, DialogActions, DialogContent, DialogTitle, List, ListItem, ListItemSecondaryAction, ListItemText } from "@material-ui/core"
import React, {Component} from "react"

/**
 * purchase
 * filter_shops
 * 
 * onSaveClick()
 * onCancelClick()
 */

class SaveDialog extends Component {

    constructor(props) {
        super(props)
    }

    render() {

        // Фильтруем вложения.
        if (this.props.filter_shops && this.props.filter_shops.length) {
            var attachments = this.props.purchase.attachments.filter(a => this.props.filter_shops.find(s => s.id === (a.shop ? a.shop.id : null)))
        } else {
            var attachments = this.props.purchase.attachments
        }

        return <Dialog open fullWidth>
            <DialogTitle>Сохранение отчёта</DialogTitle>
            <DialogContent>
                <List>
                    {attachments.map((attachment, key) => <ListItem key={key}>
                        <ListItemText
                            primary = {attachment.item.name}
                            secondary = {"Магазин:" + (attachment.shop ? attachment.shop.name : "не указан")}
                        />
                        <ListItemSecondaryAction>{attachment.quantity}</ListItemSecondaryAction>
                    </ListItem>)}
                </List>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={e=>{
                        e.stopPropagation()
                        if (typeof this.props.onSaveClick === "function") {
                            // Формируем содержимое

                            let content = "название, кол-во, магазин\n"
                            content += attachments.map(attachment => [
                                `"${attachment.item.name}"`,
                                `"${attachment.quantity}"`,
                                `"${attachment.shop ? attachment.shop.name : "не указан"}"`,
                            ].join(",")).join("\n")

                            this.props.onSaveClick(content)
                        }
                    }}
                >Сохранить</Button>
                <Button
                    onClick={e=>{
                        e.stopPropagation()
                        if (typeof this.props.onCancelClick === "function") {
                            this.props.onCancelClick()
                        }
                    }}
                >Отмена</Button>
            </DialogActions>
        </Dialog>
    }

}

export default SaveDialog
